import common from './common.json';
import featureFlags from './featureFlags.json';
import home from './home.json';
import jobfeed from './jobfeed.json';
import notfound from './notfound.json';
import subscription from './subscription.json';
import epoch from './epoch.json';
import registration from './registration.json';
import contact from './contactUs.json';

export const app = {
  common,
  featureFlags,
  home,
  jobfeed,
  notfound,
  subscription,
  epoch,
  registration,
  contact,
};
